import React from 'react';

interface IWrapperProps {
	children?: React.ReactNode;
	minSpace?: boolean;
	className?: string;
	innerClass?: string;
	animate?: boolean;
	animateFirstStep?: boolean;
	paddingTop?: 'small' | 'large';
	style?: React.CSSProperties;
}

enum EPaddingTop {
	small = 'pt-6 md:pt-8',
	large = 'pt-[72px] md:pt-8',
}

export const Wrapper = ({
	animate = false,
	animateFirstStep = false,
	minSpace = false,
	paddingTop = 'small',
	children,
	className = '',
	innerClass = '',
	style = {},
}: IWrapperProps) => (
	<div
		className={`flex px-1.5 justify-center pb-10 ${EPaddingTop[paddingTop]} ${
			minSpace ? 'pb-6 md:pb-9' : ''
		} ${className} ${animate ? 'animate-fadeInSlow relative z-10' : ''} ${
			animateFirstStep ? 'animate-stepSlideIn' : ''
		} ${animateFirstStep || animate ? 'md:pb-0' : ''}`}
		style={style}>
		<div className={`w-full flex flex-col md:max-w-desktop ${innerClass}`}>{children}</div>
	</div>
);
